export default class LayerAttribute {

    name!: string;

    label!: string;

    maxOccurs!: number;

    minOccurs!: number;

    nillable!: boolean;

    type!: string;

    localType!: string;

    display!: boolean;

    display_in_popup: boolean=true;

    editable!: boolean;

    widgetType: string='TextForm';

    widgetConfig!: any;


    constructor(input?: unknown) {
      if (input) {
        Object.assign(this, input);
      }
    }

    isBoolean():boolean {
      return this.type === 'xsd:boolean';
    }

    isText():boolean {
      return this.type === 'xsd:string';
    }

    isDate():boolean {
      return this.type === 'xsd:date';
    }

    isDateTime():boolean {
      return this.type === 'xsd:date-time';
    }

    isNumber():boolean {
      return this.type === 'xsd:number' || this.type === 'xsd:decimal'|| this.type === 'xsd:double' || this.type === 'xsd:int'|| this.type === 'xsd:long';
    }
    isGeometry():boolean {
      return this.type.indexOf('gml:')>=0;
    }

    isMandatory():boolean{
      let nillable:any=this.nillable;
      return nillable==false||nillable=="false";
    }

    toJson():any {
      return {
        name: this.name,
        label: this.label,
        maxOccurs: this.maxOccurs,
        minOccurs: this.minOccurs,
        widgetType: this.widgetType,
        widgetConfig:this.widgetConfig,
        nillable: this.nillable,
        type: this.type,
        localType: this.localType,
        display: this.display,
        display_in_popup: this.display_in_popup,
        editable: this.editable,
      };
    }
}
